import {ErrorEvent, EventHint} from '@sentry/types'
import {FETCH_ERROR_MESSAGE_PREFIX} from 'constants/validationErrorMessagesConstants'

export const beforeSend = (event: ErrorEvent, hint: EventHint) => {
  const eventMessage = event.message
  let modifiedEvent: ErrorEvent | null = event

  /****************************************************
   * Filter certain CaptureConsole integration events *
   ****************************************************/
  if (event.logger === 'console') {
    // don't sent React warnings if Sentry is enabled on localhost
    if (event.environment === 'localhost' && eventMessage?.startsWith('Warning')) {
      modifiedEvent = null
    }

    // don't send logged fetch errors, those are sent to Sentry by the HttpClient integration
    // @ts-ignore originalException is defined as unknown from the sentry lib
    if (hint.originalException?.message?.startsWith(FETCH_ERROR_MESSAGE_PREFIX)) {
      modifiedEvent = null
    }
  }

  return modifiedEvent
}
